<template>
   <div class="cup-overlay">
      <div class="cup-wrapper">

         <!-- Vapor -->
         <div class="steam-container">
            <div class="steam s1"></div>
            <div class="steam s2"></div>
            <div class="steam s3"></div>
         </div>

         <!-- Taza SVG -->
         <svg class="cup-svg" viewBox="0 0 140 110" xmlns="http://www.w3.org/2000/svg">
            <!-- Platillo -->
            <ellipse cx="64" cy="100" rx="52" ry="8" fill="#6d4c41" opacity="0.3"/>
            <!-- Cuerpo taza -->
            <path d="M20 52 Q18 86 64 88 Q110 86 108 52 Z" fill="#fff3e0" stroke="#6d4c41" stroke-width="2.5"/>
            <!-- Borde superior -->
            <ellipse cx="64" cy="52" rx="44" ry="9" fill="#fff3e0" stroke="#6d4c41" stroke-width="2.5"/>
            <!-- Té verde dentro -->
            <ellipse cx="64" cy="52" rx="40" ry="7" fill="#87b878"/>
            <!-- Reflejo -->
            <ellipse cx="52" cy="50" rx="10" ry="3" fill="#d4edcf" opacity="0.5"/>
            <!-- Asa -->
            <path d="M108 60 Q134 60 134 72 Q134 84 108 84"
               fill="none" stroke="#6d4c41" stroke-width="5" stroke-linecap="round"/>
         </svg>

         <!-- Countdown -->
         <div class="countdown">{{ segundos }}</div>

         <!-- Mensaje -->
         <div class="cup-mensaje">Cargando pagos, un momento...</div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'LoadingCup',
   data: () => ({
      segundos: 3,
      _interval: null
   }),
   mounted() {
      this._interval = setInterval(() => {
         if (this.segundos > 0) {
            this.segundos--
         } else {
            clearInterval(this._interval)
            this.$emit('done')
         }
      }, 1000)
   },
   beforeDestroy() {
      clearInterval(this._interval)
   }
}
</script>

<style scoped>
.cup-overlay {
   display: flex;
   align-items: center;
   justify-content: center;
   padding: 56px 0;
}

.cup-wrapper {
   display: flex;
   flex-direction: column;
   align-items: center;
   gap: 10px;
}

/* ── Vapor ── */
.steam-container {
   display: flex;
   gap: 18px;
   height: 56px;
   align-items: flex-end;
   margin-bottom: 0;
}

.steam {
   width: 7px;
   border-radius: 12px;
   background: linear-gradient(to top, #b2ddb0, transparent);
   animation: riseVapor 1.8s ease-in-out infinite;
   opacity: 0;
}

.s1 { height: 38px; animation-delay: 0s; }
.s2 { height: 52px; animation-delay: 0.6s; }
.s3 { height: 32px; animation-delay: 1.2s; }

@keyframes riseVapor {
   0%   { opacity: 0;   transform: translateY(0)     scaleX(1); }
   30%  { opacity: 0.8; transform: translateY(-12px)  scaleX(1.3); }
   70%  { opacity: 0.4; transform: translateY(-32px)  scaleX(0.8); }
   100% { opacity: 0;   transform: translateY(-54px)  scaleX(1.2); }
}

/* ── Taza ── */
.cup-svg {
   width: 130px;
   height: 110px;
   filter: drop-shadow(0 6px 12px rgba(0,0,0,0.18));
   animation: rockCup 2.5s ease-in-out infinite;
}

@keyframes rockCup {
   0%, 100% { transform: rotate(0deg); }
   25%       { transform: rotate(2deg); }
   75%       { transform: rotate(-2deg); }
}

/* ── Countdown ── */
.countdown {
   font-size: 52px;
   font-weight: 800;
   color: #a8d5a2;
   line-height: 1;
   font-variant-numeric: tabular-nums;
   transition: color 0.3s;
   margin-top: 4px;
}

/* ── Mensaje ── */
.cup-mensaje {
   font-size: 13px;
   color: #87b878;
   letter-spacing: 0.4px;
   font-weight: 500;
   margin-top: 2px;
}
</style>
